import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AppLayout } from '@/components/app-layout';
import { AuthCheck } from '@/components/auth-check.component';
import { FeatureGate } from '@/components/feature-gate.component';
import { Head } from '@/components/head.component';
import { Feature } from '@/constants/features';
import { AgentsGate } from '@/containers/agents/agents-gate.component';
import {
  PlayPage,
  type PlayLocation,
} from '@/containers/agents/play-page.component';

// A play from the library. An open run and the card the builder opens on are
// search params, so each links and the back button steps back through runs.
export const Route = createFileRoute('/agents/plays/$playId')({
  component: PlayRoute,
  validateSearch: (search: Record<string, unknown>): PlayLocation => {
    const out: PlayLocation = {};
    if (typeof search.run === 'string' && search.run) out.run = search.run;
    if (typeof search.node === 'string' && search.node) out.node = search.node;
    return out;
  },
});

function PlayRoute() {
  const { playId } = Route.useParams();
  const { run, node } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <>
      <Head heading='Agents' />
      <AuthCheck>
        <AppLayout variant='full-bleed'>
          <FeatureGate feature={Feature.AGENTS}>
            <AgentsGate>
              <PlayPage
                playId={playId}
                runId={run}
                nodeId={node}
                onNavigate={(next) =>
                  void navigate({
                    to: '/agents/plays/$playId',
                    params: { playId },
                    search: next,
                    // Opening a run is a step forward; leaving it is not.
                    replace: !next.run,
                  })
                }
              />
            </AgentsGate>
          </FeatureGate>
        </AppLayout>
      </AuthCheck>
    </>
  );
}
